// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css"; // Optional: Global styles if needed
// import App from "./App";
// import { GoogleOAuthProvider } from "@react-oauth/google";

// const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <GoogleOAuthProvider clientId={googleClientId}>
//       <App />
//     </GoogleOAuthProvider>
//   </React.StrictMode>
// );
// src/index.js

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";                  // your global styles
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";

// ‣ NEW: import Neo4j bits
import neo4j from "neo4j-driver";
import { Neo4jProvider } from "use-neo4j";

// ‣ NEW: build the driver from your env vars
const neo4jUri      = process.env.REACT_APP_NEO4J_URI;
const neo4jUser     = process.env.REACT_APP_NEO4J_USER;
const neo4jPassword = process.env.REACT_APP_NEO4J_PASSWORD;
const neo4jDatabase = process.env.REACT_APP_NEO4J_DATABASE;

const driver = neo4j.driver(
  neo4jUri,
  neo4j.auth.basic(neo4jUser, neo4jPassword)
);

// your existing Google client setup
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* NEW: wrap the whole tree in Neo4jProvider */}
    <Neo4jProvider driver={driver} defaultDatabase={neo4jDatabase}>
      <GoogleOAuthProvider clientId={googleClientId}>
        <App />
      </GoogleOAuthProvider>
    </Neo4jProvider>
  </React.StrictMode>
);
